import React from 'react';
import { STATS } from '../data/content';
export function Stats() {
  return <section aria-label="What is included" className="w-full bg-navy px-3 py-4 sm:px-5" data-id="element-224" data-mp="2wxqaw26lq0do">
      <div className="mx-auto max-w-5xl" data-id="element-225" data-mp="2wvdv9vobg23s">
        <p className="text-center font-head text-[10px] uppercase tracking-[0.14em] text-orange sm:text-xs" data-id="element-226" data-mp="2iyqqj6q4g7nb">
          Everything they need to learn — ready to use
        </p>
        <dl className="mt-2.5 grid grid-cols-2 gap-x-2 gap-y-2.5 lg:grid-cols-4" data-id="element-227" data-mp="298e3n7uu42e0">
          {STATS.map(stat => <div key={stat.label} className="text-center" data-id="element-228" data-mp="2dym83b5nl2ug">
              <dt className="sr-only" data-id="element-229" data-mp="2e05pj531pjxt">{stat.label}</dt>
              <dd className="font-head text-lg uppercase leading-none text-white sm:text-3xl" data-id="element-230" data-mp="2088yl4d45g30">
                {stat.value}
              </dd>
              <p className="mt-0.5 text-[9px] font-bold uppercase tracking-widest text-white/60 sm:text-[11px]" data-id="element-231" data-mp="256soffutvc0n">
                {stat.label}
              </p>
            </div>)}
        </dl>
      </div>
    </section>;
}